// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios';
import vant from 'vant';
import 'vant/lib/index.css';
import ElementUI from "element-ui";
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/reset.css';
import filters from './plugins/filters'
import VueMeta from 'vue-meta'
import './assets/css/style.css' /*引入公共样式*/
import VueCookies from 'vue-cookies'
// import {Toast}from 'vant';
Vue.use(VueCookies)
Vue.use(VueMeta, {
    refreshOnceOnNavigation: true
});
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
import {Lazyload} from 'vant';
import { Toast } from 'vant';
import Cookies from 'js-cookie';

Vue.prototype.$cookie = Cookies;
Vue.use(Lazyload);
Vue.use(Lazyload, {
    lazyComponent: true,
});
Vue.use(filters);
Vue.config.productionTip = false
Vue.prototype.$axios = axios;
axios.defaults.baseURL = '/api'  //关键代码
axios.defaults.timeout = 10000;
Vue.use(ElementUI)
Vue.use(vant);
import preventReClick from './store/preventReClick'
Vue.use(preventReClick)
const i18n = new VueI18n({
    locale: 'zh',
    messages: {
        'zh': require('@/lang/zh.js'),
        'en': require('@/lang/en.js')
    }
});
new Vue({
    el: '#app',
    router,
    store,
    i18n,
    components: {App},
    template: '<App/>'
})
// 添加请求拦截器
axios.interceptors.request.use(config => {
    //判断是否存在token，如果存在将每个页面header都添加token
    if (store.state.access_token && store.state.access_token != '') {
        //  config.headers.common['access_token'] = store.state.access_token
        config.headers.access_token = store.state.access_token
    }
    return config;
}, error => {
// 对请求错误做些什么
    return Promise.reject(error);
});
// http response 拦截器
axios.interceptors.response.use(
    response => {
        if (response.data.code == '1001') {
            store.commit('logout');
            router.push('/login')
            return
        }
        return response;
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 500:
                    Toast.fail(error.response.data.message)
            }
        }
        return Promise.reject(error.response.data)
    });


// WEBPACK FOOTER //
// ./src/main.js